import { SPOTIFY_URL_REGEX } from '../constants';

export default function spotify(Utils) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      content: '=',
    },
    template:
      '<div ng-repeat="url in urls"><iframe src="{{ url }}" width="100%" height="80" scrolling="no" frameborder="no"></iframe></div>',
    link(scope) {
      scope.urls = [];
      if (scope.content?.length) {
        const regex = new RegExp(SPOTIFY_URL_REGEX, 'g');
        let matches = regex.exec(scope.content);

        while (matches !== null) {
          const id = matches[1] ? matches[1] : matches[2];
          scope.urls.push(`https://open.spotify.com/embed/track/${id}`);
          matches = regex.exec(scope.content);
        }

        scope.urls = Utils.uniq(scope.urls);
      }
    },
  };
}
